import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { CardContent, Box, makeStyles } from '@applyboard/ui-components';
import { Bar, Blurb, Frame, ConditionalInfo, useFeatures, IneligibleDetails } from "./components";
import { useAppContext } from "../../../Providers";
import { useCefEventTracker } from "../../../Hooks/useCefEventTracker";
import { CefEvent, Platform } from "../../../../../EventTracker";
var useStyles = makeStyles({
  content: {
    padding: '24px 24px 22px 24px'
  }
});
var EligibilityInfoMobile = function EligibilityInfoMobile(props) {
  var result = props.result,
    program = props.program,
    searchData = props.searchData;
  var _useCefEventTracker = useCefEventTracker(),
    trackEvent = _useCefEventTracker.trackEvent;
  var onTrack = function onTrack(eventName, data) {
    trackEvent(CefEvent(eventName, Platform.Mobile, data));
  };
  var _useAppContext = useAppContext(),
    userId = _useAppContext.userId,
    ineligibleRegisterRedirect = _useAppContext.ineligibleRegisterRedirect,
    exploreAction = _useAppContext.exploreAction;
  var _useFeatures = useFeatures({
      programId: program.id,
      result: result,
      searchData: searchData,
      isMobile: true,
      userId: userId,
      onTrack: onTrack,
      trackEvent: trackEvent,
      exploreAction: exploreAction,
      ineligibleRegisterRedirect: ineligibleRegisterRedirect
    }),
    color = _useFeatures.color,
    message = _useFeatures.message,
    imgSrc = _useFeatures.imgSrc,
    imgAlt = _useFeatures.imgAlt,
    buttons = _useFeatures.buttons,
    conditional = _useFeatures.conditional,
    ineligible = _useFeatures.ineligible;
  var showIneligibleDetails = userId && ineligible;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Bar, {
    color: color
  }), /*#__PURE__*/React.createElement(CardContent, {
    className: classes.content
  }, program.id && /*#__PURE__*/React.createElement(Frame, {
    src: imgSrc,
    alt: imgAlt
  }, /*#__PURE__*/React.createElement(Box, {
    ml: "16px"
  }, /*#__PURE__*/React.createElement(Blurb, {
    program: program
  }, message))), conditional && /*#__PURE__*/React.createElement(ConditionalInfo, {
    eslMessage: program === null || program === void 0 ? void 0 : program.conditionalAcceptanceText
  }), showIneligibleDetails && /*#__PURE__*/React.createElement(IneligibleDetails, {
    program: program,
    student: searchData,
    result: result
  })), buttons);
};
export default EligibilityInfoMobile;